const crypto = require('crypto');
const algorithm = 'aes-256-cbc';
const key = Buffer.from(ENCRYPT_KEY, 'hex');
const iv = crypto.randomBytes(16);
function encrypt(text) {
    try {
        const cipher = crypto.createCipheriv(algorithm, key, iv);
        let encrypted = cipher.update(text, 'utf8', 'hex');
        encrypted += cipher.final('hex');
        return iv.toString('hex') + encrypted;
    }
    catch (e) {
        console.error(e);
    }
}
function decrypt(encrypted) {
    try {
        const iv = Buffer.from(encrypted.slice(0, 32), 'hex');
        const decipher = crypto.createDecipheriv(algorithm, key, iv);
        let decrypted = decipher.update(encrypted.slice(32), 'hex', 'utf8');
        decrypted += decipher.final('utf8');
        return decrypted;
    }
    catch (e) {
        console.error(e);
    }
}
module.exports = {
    encrypt,
    decrypt,
};
